import { action, observable } from 'mobx'

import Ds from './ds'

class Organizations {
  @observable data = []
  @observable details = {}

  @observable ds = new Ds()

  @action loadAllOrganizations(callback) {
    this.ds.query(`{ organizations(hash: "${ localStorage.getItem('userHash') }") { id name address city state zipCode email phone url logo } }`, (data) => {
      this.data = data.organizations
    })

    if (callback) {
      return callback(this.data)
    }
  }

  @action loadOrganization(id, callback) {
    let query = `{ organizations(id: ${ id }, hash: "${ localStorage.getItem('userHash') }") { id name address city state zipCode phone email url logo } }`

    console.log(query)

    this.ds.query(query, (data) => {
      this.details = data.organizations[0]

      if (callback) {
        return callback(this.details)
      }
    })
  }

  @action newOrganization(row) {
    let query = `mutation { addOrganization(
      organizationId: ${ row.organizationId },
      name: "${ row.name }",
      address: "${ row.address }",
      city: "${ row.city }",
      state: "${ row.state }",
      zipCode: "${ row.zipCode }",
      email: "${ row.email }",
      phone: "${ row.phone }",
      url: "${ row.url }",
      hash: "${ localStorage.getItem('userHash') }") { id } }`

    console.log(query)
    this.ds.query(query, (data) => {
      this.loadAllOrganizations()
    })
  }

  @action updateOrganization(data) {
    let query = `mutation { updateOrganization(
      id: ${ data.id },
      name: "${ data.name }",
      address: "${ data.address }",
      city: "${ data.city }",
      state: "${ data.state }",
      zipCode: "${ data.zipCode }",
      email: "${ data.email }",
      phone: "${ data.phone }",
      url: "${ data.url }",
      hash: "${ localStorage.getItem('userHash') }"
    ) { id }}`

    console.log(query)
    
    this.ds.query(query, (data) => {
      this.loadAllOrganizations()
    })
  }

  @action deleteOrganization(id) {
    this.ds.query(`mutation { deleteOrganization(id: ${ id }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllOrganizations()
    })
  }
}

export default new Organizations()



// WEBPACK FOOTER //
// ./src/stores/organizations.js